import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import "./assets/css/styles.css";

//import './scripts.js'
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";

library.add(fas, fab);
dom.watch();

createApp(App).use(router).mount("#app");




